import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";
import { getFeaturedArticles, getHotArticles, formatViews } from "@/utils/content";

const allTags = Array.from(new Set(articles.flatMap((a) => a.tags)));

export default function HotSidebar() {
  const hot = getHotArticles().slice(0, 6);
  const picks = getFeaturedArticles().slice(0, 2);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-4 flex items-center gap-2">
          <i className="ri-fire-fill text-lg text-primary-500" />
          <h3 className="text-base font-bold text-foreground-950">热门阅读榜</h3>
        </div>
        <div className="flex flex-col gap-1">
          {hot.map((a, i) => (
            <div key={a.id} className="flex items-start gap-1">
              <span
                className={`mt-1.5 flex h-5 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  i < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-500"
                }`}
              >
                {i + 1}
              </span>
              <Link
                to={`/detail/${a.id}`}
                className="group flex-1 cursor-pointer rounded-md p-2 transition-colors hover:bg-background-100"
              >
                <span className="line-clamp-2 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                  {a.title}
                </span>
                <span className="mt-1 block text-xs text-foreground-400">{formatViews(a.views)} 阅读</span>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-4 flex items-center gap-2">
          <i className="ri-award-fill text-lg text-accent-500" />
          <h3 className="text-base font-bold text-foreground-950">编辑精选</h3>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
          {picks.map((a) => (
            <ArticleCard key={a.id} article={a} variant="grid" />
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-4 flex items-center gap-2">
          <i className="ri-price-tag-3-fill text-lg text-secondary-500" />
          <h3 className="text-base font-bold text-foreground-950">热门标签</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {allTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="cursor-pointer rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}